<template>
    <a-config-provider :locale="locale" :getPopupContainer="getPopupContainer">
        <a-spin tip="Loading..." :spinning="loading">
            <div id="app">
                <router-view />
            </div>
        </a-spin>
    </a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/es/locale/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

export default {
    name: 'app',
    data() {
        return {
            locale: zh_CN
        }
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && this.$store.state.Loading.full
        }
    },
    methods: {
        getPopupContainer(el, dialogContext) {
            if (dialogContext) {
                return dialogContext.getDialogWrap()
            } else {
                return document.body
            }
        }
    }
}
</script>

<style>
@import '~nprogress/nprogress.css';

#nprogress .spinner {
    display: none !important;
}

* {
    padding: 0;
    margin: 0;
}

body {
    font-family: 'PingFang SC', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    min-width: 1366px;
}

/* 滚动条 start*/

::-webkit-scrollbar {
    width: 7px;
    height: 4px;
    background-color: #f5f5f5;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background: #fff;
}

::-webkit-scrollbar-thumb {
    border-radius: 3px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(158, 158, 158, 0.7);
}

::-webkit-scrollbar-thumb:hover {
    border-radius: 3px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: rgba(158, 158, 158, 1);
}

.amap {
    width: 100%;
    height: 500px;
}

.flex-x-space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ant-descriptions-item-label {
    width: 140px !important;
}
</style>
